<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="广告板块设置"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="链接类型" label-width="85px">
          <el-select
            v-model="params.AdType"
            placeholder="请选择链接类型"
            clearable
          >
            <el-option label="静态展示" :value="0"></el-option>
            <!-- <el-option label="活动链接" :value="1"></el-option> -->
            <!-- <el-option label="页面链接" :value="2"></el-option> -->
            <el-option label="商品分类" :value="3"></el-option>
            <el-option label="指定商品" :value="4"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="OrderId"
          label="排序"
          align="center"
          width="60"
        />
        <!--  <el-table-column prop="SectionId" label="板块ID" /> -->
        <el-table-column prop="PhotoTitle" label="广告主题" />
        <el-table-column prop="AdType" label="链接类型">
          <template slot-scope="{ row }">
            <span v-if="row.AdType == 0">静态展示</span>
            <span v-else-if="row.AdType == 1">活动链接</span>
            <span v-else-if="row.AdType == 2">页面链接</span>
            <span v-else-if="row.AdType == 3">商品分类</span>
            <span v-else-if="row.AdType == 4">指定商品</span>
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import editDialog from "./editDialog";

export default {
  mixins: [listMixin],
  components: { list, editDialog },

  data() {
    return {
      api: require("@/api/mall/sectionad").default,
      params: {
        SectionId: "",
        AdType: null,
      },
    };
  },
  getData() {
    //  this.$refs.editDialog.getData({SectionId:SectionId});
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>